<template>
	<div class="container">
		<div v-html="detailmodel.awards">
			
		</div>
	</div>
</template>

<script>
	import competitionModules from '@/modules/competition.js'
	export default {
		name: 'competitionPrize',
		components: {
			
		},
		mixins: [
			competitionModules
		],
		data(){
			return {
				
			}
		},
		methods: {
			
		}
	}
</script>

<style lang="less" scoped>
	.container{
		img{
			max-width: 100%;
		}
	}
</style>
